import React from 'react';
import './services.css';

export default function Services() {
  return (
    <section className="service_container">
      <section className="services_limit">
        <section className="service_content">
          <span>Contato</span>
          <span>LGPD</span>
          <span>Política de Cancelamento</span>
          <span>Política de Cookies</span>
          <span>Política de Privacidade</span>
          <span>Termo de Adesão Cloud</span>
          <span>Termos de Uso</span>
          <span>Política Comercial</span>
          <span>Política de Garantia</span>
          <span>Perguntas Frequentes</span>
          <span>Sobre a Altatech</span>
        </section>
        <section className="service_content gray_font">
          <span>Atendimento de Segunda a Sexta das 08:00 às 18:00</span>
          <span>Av. Juscelino Kubitscheck, 1905 - Centro</span>
          <span>CEP 86010-540 - Londrina - PR</span>
          <span>comercial@altatech.com.br</span>
        </section>
        <section className="service_content gray_font">
          <span>Copyright © 2022</span>
          <span>Todos os Direitos Reservados</span>
          <span>CNPJ: 05.365.132/0001-30</span>
        </section>
      </section>
    </section>
  );
}
